import { differenceInMinutes, parseISO } from 'date-fns'
import { TRIP_STATUS } from 'types'

const MINUTES_PER_HOUR = 60
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR

function pluralize(count, unit) {
  return `${count} ${unit}${count === 1 ? '' : 's'}`
}

// Expired trips are billed as exactly one hour. Otherwise the duration is the
// time between check in and check out, dropping leading units that are zero
// (e.g. "15 minutes" rather than "0 days, 0 hours, 15 minutes").
export default function formatTripDuration({
  status,
  createdAt,
  checkedOutAt,
}) {
  if (status === TRIP_STATUS.EXPIRED) return '1 hour'
  if (!createdAt || !checkedOutAt) return '—'

  const totalMinutes = Math.max(
    differenceInMinutes(parseISO(checkedOutAt), parseISO(createdAt)),
    0
  )
  const days = Math.floor(totalMinutes / MINUTES_PER_DAY)
  const hours = Math.floor((totalMinutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR)
  const minutes = totalMinutes % MINUTES_PER_HOUR

  const parts = []
  if (days > 0) parts.push(pluralize(days, 'day'))
  if (days > 0 || hours > 0) parts.push(pluralize(hours, 'hour'))
  parts.push(pluralize(minutes, 'minute'))
  return parts.join(', ')
}
